import 'selectize';
import datepicker from 'js-datepicker';
(function () {
  initSelect();
  initDatepicker();
})();
function initSelect() {
  const $select = '.gfield_select';
  const $locationSelect = '.js-select';
  jQuery($select).selectize();
  jQuery($locationSelect).selectize();
  jQuery(document).bind('gform_post_render', function () {
    jQuery('.gform_validation_error .gfield_select').selectize();
  });
}
function initDatepicker() {
  let inputClass = '.js-move-date input';
  if (document.querySelector(inputClass)) {
    const picker = datepicker(inputClass, {});
  }
}